/* RESPONSIBLE TEAM: team-standalone */

import { tracked } from '@glimmer/tracking';
import { isPresent } from '@ember/utils';
import {
  type FieldType,
  type IntercomAttributeType,
} from 'embercom/objects/standalone/data-fields/common';

export interface OrganizationFieldResponse {
  id: string;
  name: string;
  description?: string;
  type: FieldType;
  required: boolean;
  intercom_cda?: {
    identifier: string;
    type: IntercomAttributeType;
  };
  intercom_sda?: {
    identifier: string;
    type: IntercomAttributeType;
  };
  built_in?: boolean;
}

export class OrganizationField {
  id: string;
  name: string;
  description?: string;
  type: FieldType;
  required: boolean;
  @tracked isSynchronizing?: boolean = false;
  intercom_cda?: {
    identifier: string;
    type: IntercomAttributeType;
  };
  intercom_sda?: {
    identifier: string;
    type: IntercomAttributeType;
  };
  builtIn: boolean;

  constructor(response: OrganizationFieldResponse) {
    this.id = response.id;
    this.name = response.name;
    this.description = response.description;
    this.type = response.type;
    this.required = response.required;
    this.intercom_cda = response.intercom_cda;
    this.intercom_sda = response.intercom_sda;
    this.builtIn = response.built_in || false;
  }

  get intercomCdaIdentifier() {
    return this.intercom_cda?.identifier;
  }

  get intercomSdaIdentifier() {
    return this.intercom_sda?.identifier;
  }

  get synchronized() {
    return isPresent(this.intercom_cda?.identifier);
  }

  get attributeDataType() {
    return this.intercom_cda?.type || this.intercom_sda?.type;
  }

  get createable(): boolean | undefined {
    return undefined;
  }

  get updateable(): boolean | undefined {
    return undefined;
  }
}
